import React from 'react';
import styled from 'styled-components/macro';
import LayoutWrapper from 'routes/tourOperator/flightCache/comp/utility/layoutWrapper';
import LayoutContent from 'routes/tourOperator/flightCache/comp/utility/layoutContent';
import SwitchMenu from 'routes/tourOperator/flightCache/comp/flightCache/SwitchMenu';
import FlightDefinitionGroupTable from './comp/flightDefinitionGroupsTable/FlightDefinitionGroupTable';

function FlightDefinitionGroups() {
  return (
    <LayoutWrapper>
      <LayoutContent>
        <SwitchMenu />
        <Root>
          <FlightDefinitionGroupTable />
        </Root>
      </LayoutContent>
    </LayoutWrapper>
  );
}

export default FlightDefinitionGroups;

const Root = styled.div`
  display: flex;
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
